import { defineComponent } from 'vue';
import AuditorEntriesTableCode from '@/presentation/components/auditor/auditor-entries-table/auditor-entries-table.code';

export default defineComponent({
	setup: () => {
		const code = new AuditorEntriesTableCode();

		return {
			entityKeyStudy: code.entityKeyStudy,
			entityKeyOrganisation: code.entityKeyOrganisation,
			refinedAuditorEntries: code.refinedAuditorEntries,
			isPricingConfigurationAvailable: code.isPricingConfigurationAvailable.bind(code),
			isGeoConfigurationRemoved: code.isGeoConfigurationRemoved.bind(code),
			areGeoRemaindersAvailable: code.areGeoRemaindersAvailable.bind(code),
			formatDateString: code.formatDateString.bind(code),
			getPricingCountForEntryAndKey: code.getPricingCountForEntryAndKey.bind(code),
			getPerformingUserNameForEntry: code.getPerformingUserNameForEntry.bind(code)
		};
	}
});
